module.exports = {
      id: "info-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }